import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../components/Screen/Screen';
import { ScreenHeader } from '../../components/ScreenHeader/ScreenHeader';
import { Button } from '../../components/Button/Button';
import { copy } from '../../constants';
import './Confirmation.css';

export const Confirmation: React.FC = () => {
  const navigate = useNavigate();

  const handleDone = () => {
    navigate('/');
  };

  return (
    <Screen className="confirmation">
      <div className="confirmation__content">
        <div className="confirmation__icon">✓</div>
        
        <ScreenHeader
          title={copy.confirmation.title}
          subtitle={copy.confirmation.subtitle}
        />
        
        <p className="confirmation__message">
          {copy.confirmation.message}
        </p>
      </div>
      
      <div className="confirmation__actions">
        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={handleDone}
        >
          {copy.confirmation.button}
        </Button>
      </div>
    </Screen>
  );
};
